import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({providedIn: 'root'})
export class EscalaProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {

  }

  getFuncoesSemPessoa(entidade: any, idEntidade: any, pag: { currentPage: any; }, filtro: any, tipo = "") {
    return this.http.get<any>(this.baseUrl + '/escala/funcoes-sem-pessoa',
      {
        observe: 'response', params:
        {
          "page": pag.currentPage,
          "per-page": "10",
          "filtro": filtro,
          "entidade": entidade,
          "idEntidade": idEntidade,
          "tipo": tipo
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          funcoes: data.body,
          pagination: pag
        };
      }));
  }

  getFuncoesPessoa(entidade: any, idEntidade: any, idPessoa: any) {
    return this.http.post<any>(this.baseUrl + '/escala/funcoes-pessoa', { entidade: entidade, idEntidade: idEntidade, idPessoa: idPessoa })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  removerPessoaFuncao(idEscalaFuncaoPessoa: any) {
    return this.http.post<any>(this.baseUrl + '/escala/remover-pessoa-funcao', { id: idEscalaFuncaoPessoa })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  addPessoaFuncao(entidade: any, idEntidade: any, idPessoa: any, idFuncao: any, idEscala: any) {
    return this.http.post<any>(this.baseUrl + '/escala/add-pessoa-funcao',
      {
        entidade: entidade,
        idEntidade: idEntidade,
        idPessoa: idPessoa,
        idFuncao: idFuncao,
        idEscala: idEscala
      })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  addPessoaFuncoes(entidade: any, idEntidade: any, pessoas: any, idFuncao: any, idEscala: any) {
    return this.http.post<any>(this.baseUrl + '/escala/add-pessoa-funcoes',
      {
        entidade: entidade,
        idEntidade: idEntidade,
        pessoas: pessoas,
        idFuncao: idFuncao,
        idEscala: idEscala
      })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getGrupos(filtro: any, tipoGrupo: any, regiao: any, dia: any, tipo: any, pag: { currentPage: any; }) {
    return this.http.get<any>(this.baseUrl + '/escala/get-grupos-escala',
      {
        observe: 'response', params:
        {
          "page": pag.currentPage,
          "per-page": "10",
          "filtro": filtro,
          "tipoGrupo": tipoGrupo,
          "regiao": regiao,
          "dia": dia,
          "tipo": tipo
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          grupos: data.body,
          pagination: pag
        };
      }));

  }

  getPessoas(filtro: any, grupo = '', entidade: any, idEntidade: any, idFuncao: any, pag: { currentPage: any; }) {
    return this.http.get<any>(this.baseUrl + '/escala/get-pessoas',
      {
        observe: 'response', params:
        {
          "page": pag.currentPage,
          "per-page": "10",
          "filtro": filtro,
          "idFuncao": idFuncao,
          "grupo": grupo,
          "entidade": entidade,
          "idEntidade": idEntidade
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          pessoas: data.body,
          pagination: pag
        };
      }));

  }


}
